// Configuration pour Mapbox GL JS
import mapboxgl from 'mapbox-gl';

// Désactive le worker pour éviter les problèmes de transpilation
mapboxgl.workerClass = null;

export default mapboxgl;
